import React from "react";
import { Transfer } from "antd";
import { TransferItem, RenderResult } from "antd/lib/transfer";

interface CitySelectProps {
  value?: string[];
  dataSource: Array<TransferItem>;
  onChange?: (active: string[], notActive: string[]) => void;
}

const CitySelect: React.FC<CitySelectProps> = ({ value = [], dataSource, onChange }) => {
  const [target, setTarget] = React.useState<Array<string>>(value);
  const [selectedKeys, setSelectedKeys] = React.useState<Array<string>>([]);

  const triggerInputChange = (active: string[], notActive: string[]) => {
    if (onChange) {
      onChange([...active], [...notActive]);
    }
  };

  const handleSelectChange = (sourceSelectedKeys: string[], targetSelectedKeys: string[]) => {
    setSelectedKeys([...targetSelectedKeys, ...sourceSelectedKeys]);
  };

  const handleChange = (nextTargetKeys: string[]) => {
    setTarget(nextTargetKeys);
    const notActivated = dataSource.reduce((acc, curr) => {
      if (curr.key && !nextTargetKeys.includes(curr.key)) {
        acc.push(curr.key);
      }
      return acc;
    }, [] as string[]);
    triggerInputChange(nextTargetKeys, notActivated);
  };

  React.useEffect(() => {
    setTarget(value);
  }, [value]);

  return (
    <Transfer
      dataSource={dataSource}
      titles={["Inactive", "Active"]}
      targetKeys={target}
      selectedKeys={selectedKeys}
      onSelectChange={handleSelectChange}
      onChange={handleChange}
      render={(item) => item.title as RenderResult}
    />
  );
};

export default CitySelect;
